import Vue from 'vue';
import Service from './service';

export const CLEAR_MODULE = 'CLEAR_MODULE';
export const UPDATE_ERROR = 'UPDATE_ERROR';
export const UPDATE_LOADED = 'UPDATE_LOADED';
export const UPDATE_APPRAISERS = 'UPDATE_APPRAISERS';
export const saveAppraiserAction = 'saveAppraiserAction';
export const initModuleAction = 'initModuleAction';
export default {
  namespaced: true,
  state: {
    error: '',
    loaded: false,
    types: {},
    appraisers: [],
  },
  mutations: {
    [CLEAR_MODULE](state) {
      Vue.set(state, 'types', {});
      Vue.set(state, 'loaded', false);
      Vue.set(state, 'error', '');
      Vue.set(state, 'appraisers', []);
    },
    [UPDATE_ERROR](state, payload) {
      Vue.set(state, 'error', payload);
    },
    [UPDATE_LOADED](state, payload) {
      Vue.set(state, 'loaded', payload);
    },
    [UPDATE_APPRAISERS](state, payload) {
      state.appraisers.push(payload);
    },
  },
  actions: {
    [initModuleAction]({ commit }) {
      commit(CLEAR_MODULE);
      return Service.getAllAppraisers()
        .then(list => list.forEach(appraiser => commit(UPDATE_APPRAISERS, appraiser)))
        .then(() => commit(UPDATE_LOADED, true));
    },
    [saveAppraiserAction]({ commit, dispatch }, payload) {
      let promise = null;
      if ('id' in payload && payload.id !== 'dummy') {
        promise = Service.updateAppraisers(payload);
      } else if ('id' in payload && payload.id === 'dummy') {
        promise = Service.saveAppraiser(payload);
      } else {
        promise = Promise.reject('Incorrect data to save');
      }
      return promise.then(() =>
        dispatch('initModuleAction'));
    },
  },
  getters: {
    loaded: state => state.loaded,
    appraisers: state => state.appraisers,
  },
};



// WEBPACK FOOTER //
// ./src/features/appraiser/store.js